import React, { useState } from 'react';
import verifiedBadge from '../../assets/verified.png';

export default function Avatar({ src, name, size = 10, className = '' }) {
  const [imgError, setImgError] = useState(false);
  const initials = name
    ? name
        .split(' ')
        .map((n) => n[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : 'U';

  return (
    <div className="relative inline-block">
      <div className={`inline-flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 overflow-hidden ${className}`} style={{ width: size * 4, height: size * 4 }}>
        {src && !imgError ? (
          <img src={src} alt={name} className="w-full h-full object-cover" onError={() => setImgError(true)} />
        ) : (
          <span className="font-semibold" style={{ fontSize: `${size * 1.5}px` }}>{initials}</span>
        )}
      </div>
    </div>
  );
}
